export enum OrganizationProfile {
    PRODUCTION = 0,
    SANDBOX = 1
}

export class OrganizationProfileUtil {
    public static getName(profile: OrganizationProfile): string | undefined {
        const names = new Map<OrganizationProfile, string>([
            [OrganizationProfile.PRODUCTION, 'Production'],
            [OrganizationProfile.SANDBOX, 'Sandbox']
        ]);
        return names.get(profile);
    }
}
